// extracted by mini-css-extract-plugin
export default {"mainContent":"MainContent_mainContent__TcaNo","mainWindow":"MainContent_mainWindow__pXL7x"};